const EvmIcon = (
  <svg width="42" height="32" viewBox="0 0 42 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="42" height="32" rx="6" fill="#212121" />
    <g clipPath="url(#clip0_3823_6897)">
      <g clipPath="url(#clip1_3823_6897)">
        <path
          d="M36 0H6C2.68629 0 0 2.68629 0 6V26C0 29.3137 2.68629 32 6 32H36C39.3137 32 42 29.3137 42 26V6C42 2.68629 39.3137 0 36 0Z"
          fill="#97FCE4"
        />
        <path
          d="M31.8226 15.8991C31.8226 23.0173 27.443 25.3014 25.1356 23.2677C23.2361 21.6094 22.671 18.105 19.814 17.7452C16.1879 17.2915 15.874 22.0944 13.4879 22.0944C10.7095 22.0944 10.1758 18.0737 10.1758 16.0087C10.1758 13.8966 10.7723 11.018 13.1426 11.018C15.9054 11.018 16.0623 15.1326 19.5158 14.9135C22.9535 14.6789 23.0163 10.3923 25.2455 8.56186C27.1919 6.98175 31.8226 8.68701 31.8226 15.8991Z"
          fill="#072723"
        />
        <path
          d="M5.06 29.5V23.74H8.78V24.644H6.024V26.064H8.3V26.968H6.024V28.596H8.78V29.5H5.06ZM10.9357 29.5L9.11969 23.74H10.1117L11.6317 28.564L13.1717 23.74H14.1637L12.3477 29.5H10.9357ZM14.6647 29.5V23.74H15.5327L17.5247 27.82L19.5167 23.74H20.3847V29.5H19.4847V25.808L17.7167 29.5H17.3327L15.5687 25.808V29.5H14.6647Z"
          fill="#072723"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_3823_6897">
        <rect width="42" height="32" fill="white" />
      </clipPath>
      <clipPath id="clip1_3823_6897">
        <rect width="42" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default EvmIcon
